import { ESTATE_SORTING_VALUES } from '../constants';

import type { SortConfigs } from '../types';

export const managersSortConfigs: SortConfigs = [
  {
    titles: {
      en: 'By price',
      ru: 'По цене',
    },
    sortKey: {
      asc: ESTATE_SORTING_VALUES.PRICE_ASC,
      desc: ESTATE_SORTING_VALUES.PRICE_DESC,
    },
    type: 'order',
    defaultSelected: true,
  },
  {
    titles: {
      en: 'By novelty',
      ru: 'По новизне',
    },
    sortKey: {
      asc: ESTATE_SORTING_VALUES.PUBLISHED_AT_ASC,
      desc: ESTATE_SORTING_VALUES.PUBLISHED_AT_DESC,
    },
    type: 'order',
  },
  {
    titles: {
      en: 'By area',
      ru: 'По площади',
    },
    sortKey: {
      asc: ESTATE_SORTING_VALUES.TOTAL_AREA_ASC,
      desc: ESTATE_SORTING_VALUES.TOTAL_AREA_DESC,
    },
    type: 'order',
  },
];
